module.exports = __webpack_public_path__ + "static/media/6.8308d878.jpg";